import { render, staticRenderFns } from "./PasswordConfirm.vue?vue&type=template&id=5c403ddd&scoped=true&"
import script from "./PasswordConfirm.vue?vue&type=script&lang=js&"
export * from "./PasswordConfirm.vue?vue&type=script&lang=js&"
import style0 from "./PasswordConfirm.vue?vue&type=style&index=0&id=5c403ddd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c403ddd",
  null
  
)

export default component.exports